import { Stack, TextColors, Typography } from '@sureco/design-system'
import { Divider, Image } from '@surecompanies/core_components'
import { HRISMap } from 'enrollment-platform/components/form/HrisSelect'
import { industryMap } from 'enrollment-platform/components/form/IndustrySelect/industry.data'
import { Collapse } from 'antd'
import React from 'react'
import {
  BusinessStructureEnum,
  BusinessStructureLabels,
} from '../../../enums/bussiness.type'
import useCanViewConfigurationHistory from '../hooks/useCanViewConfigurationHistory'
import CustomerConfigurationHistory from './CustomerConfigurationHistory'
import CustomerDetailConfiguration from './CustomerDetailConfiguration'

export default function CustomerDetails({ customer }) {
  const canViewConfigurationHistory = useCanViewConfigurationHistory()
  if (!customer) return null
  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 2fr',
          columnGap: 10,
        }}
      >
        <Stack space={10}>
          {customer.companyLogoUrl && (
            <Image
              width={200}
              src={customer.companyLogoUrl}
              style={{ border: '1px solid #AAB5BD' }}
            />
          )}
          <Typography color={TextColors.primary} size={16}>
            {customer.webSiteUrl}
          </Typography>
        </Stack>
        <Stack style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
          <Stack space={10}>
            <Stack>
              <Typography color="#999" size={16}>
                {customer.internalCompanyName}
              </Typography>
              <Stack>
                <Typography size={16} bold color="#003146">
                  Industry
                </Typography>
                <Typography color="#003146" size={16}>
                  {industryMap[customer.industry] ?? ''}
                </Typography>
              </Stack>
              <Stack>
                <Typography size={16} bold color="#003146">
                  Business Structure
                </Typography>
                <Typography color="#003146" size={16}>
                  {BusinessStructureLabels[
                    customer.businessStructure as BusinessStructureEnum
                  ] ??
                    customer.businessStructure ??
                    ''}
                </Typography>
              </Stack>
              <Stack>
                <Typography size={16} bold color="#003146">
                  Payroll / HRIS Vendor
                </Typography>
                <Typography color="#003146" size={16}>
                  {HRISMap[customer.payrollVendorName] ?? ''}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
          <Stack>
            <Stack>
              <Typography size={16} bold color="#003146">
                Address
              </Typography>
              <Typography color="#003146" size={16}>
                {customer.address?.streetAddressLine1}{' '}
                {customer.address?.streetAddressLine2}
              </Typography>
              <Typography color="#999" size={16}>
                {customer.address?.city}, {customer.address?.stateProvince}{' '}
                {customer.address?.postalCode}
              </Typography>
            </Stack>
            <Stack>
              <Typography size={16} bold color="#003146">
                Phone
              </Typography>
              <Typography color="#003146" size={16}>
                {customer.phoneNumber}
              </Typography>
            </Stack>
            {customer.taxId && (
              <Stack>
                <Typography size={16} bold color="#003146">
                  TaxID
                </Typography>
                <Typography color="#003146" size={16}>
                  {customer.taxId}
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
      </div>
      <Divider />
      <CustomerDetailConfiguration customer={customer} />
      {/* Platform Hixme Admin only. Panel content is mounted (and fetched) only once it is first opened. */}
      {canViewConfigurationHistory ? (
        <Collapse
          ghost
          style={{ marginTop: 16 }}
          items={[
            {
              key: 'configuration-history',
              label: 'Configuration history',
              children: (
                <CustomerConfigurationHistory customerId={customer.id} />
              ),
            },
          ]}
        />
      ) : null}
    </>
  )
}
